"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["short"] = exports["long"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    0% {\n        transform: translateX(0%) scaleX(0.5); \n    }\n    60% {\n        transform: translateX(500%) scaleX(2.5); \n    } \n    100% { \n        transform: translateX(1000%) scaleX(1); \n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    0% { \n        transform: translateX(-35%) scaleX(0); \n    } \n    60% {\n        transform: translateX(450%) scaleX(3); \n    } \n    100% {\n        transform: translateX(600%) scaleX(0); \n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _long = (0, _styledComponents.keyframes)(_templateObject());

exports["long"] = _long;

var _short = (0, _styledComponents.keyframes)(_templateObject2());

exports["short"] = _short;